jQuery(document).ready(function() {

   
    jQuery('.slider.banner .slider__main .slide .image--background').each(function(){
        if(jQuery(this).find('.img').length > 0){
           var bannerimg = jQuery(this).find('.img').attr('src');
           jQuery(this).css("background-image", "url(" + bannerimg + ")");
        }

    });
	 jQuery('.views-element-container .js-slider-main').slick('unslick');
	 jQuery('.news--banner .js-slider-main').slick('unslick');
	 
     if(jQuery('.news-slider').length > 0){
		jQuery('.news-slider').slick({
			infinite: true,
			dots: true,
			speed: 700,
			arrows: true,
			slidesToShow:1,
			autoplay:true,
			autoplaySpeed:7500,
			pauseOnHover: false,
			nextArrow: '<button class="right-arrow"><span class="sr-only">right arrow</span></button>',
			prevArrow: '<button class="left-arrow"><span class="sr-only">left arrow</span></button>',
			dotsClass: 'custom_paging',
			customPaging: function (slider, i) {
				return (i + 1) + ' / ' + slider.slideCount;
			},
			responsive: [
				{
				  breakpoint: 767,
				  settings: {
					autoplay: false
				  }
				}
			  ]
		});

		if(window.matchMedia('(min-width:767px)').matches){
			jQuery('.news-slider .custom_paging').before("<span class='autoplay play'>play</span>");
		}
		jQuery('.autoplay').on('click', function() {
			if(jQuery('.autoplay').hasClass('play')){
				jQuery('.autoplay').removeClass('play').addClass('pause');
				jQuery('.news-slider').slick('slickPause');
			}
			else if(jQuery('.autoplay').hasClass('pause')){
				jQuery('.autoplay').removeClass('pause').addClass('play');
				jQuery('.news-slider').slick('slickPlay');
			}
		});

		jQuery('.video-content .js-play-video').on('click', function() {
			jQuery('.news-slider').slick('slickPause');
			jQuery('.autoplay').removeClass('play').addClass('pause');
			if(jQuery('.mfp-gallery .mejs__controls').find('.mejs__playpause-button').hasClass('mejs__play')){
				jQuery('.mfp-gallery .mejs__controls .mejs__playpause-button.mejs__play button').click();
			}
		});
		
		if(jQuery('.mfp-close').length > 0){
			jQuery('.mfp-close').one('click', function(e) {
				console.log('close popup');
				if(jQuery('.mfp-wrap').length == 0){
					setTimeout(function(){
						jQuery('.news-slider').slick('slickPlay');
						jQuery('.autoplay').removeClass('pause').addClass('play');
					});
				}
				setTimeout(function(){
					jQuery('.news-slider').slick('slickPlay');
					jQuery('.autoplay').removeClass('pause').addClass('play');
				});
			});
		}
		
		// jQuery('.video-image__slider .slick-arrow,.video-image__slider .custom_paging li').on('click', function(){
		// 	jQuery('.video-image__slider .slick-track .slick-slide').each(function(){
		// 		if(jQuery(this).find('.mejs__playpause-button').hasClass('mejs__pause')){
		// 			jQuery('.mejs__playpause-button.mejs__pause button').click();
		// 		}
		// 	});
		// });

	}
	
	
	//iframe slider js
	if(jQuery('.iframe-popup-video').length > 0){
		jQuery('.iframe-popup-video').on('click',function(e){
			e.preventDefault();
			jQuery('.news-slider').slick('slickPause');
			jQuery('.autoplay').removeClass('play').addClass('pause');
		});
		jQuery('.iframe-popup-video').magnificPopup({
			type: 'iframe',
			iframe: {
				markup: '<div class="mfp-iframe-scaler">' +
					'<div class="mfp-close"></div><div class="mfp-title"></div>' +
					'<iframe class="mfp-iframe" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>'
			}, 
			callbacks: {
				markupParse: function (template, values, item) {
					values.title = item.el.attr('title');
				}
			}
		});
	}

	
}); //Document Ready End
